/**
 * Reading a room-owned table for a WHOLE project, in one request (2026-09-22).
 *
 * `specs`, `schedule_entries`, `punch_items` and `room_feedback` all hang off
 * a room, not a project. Each module used to fetch the project's room ids and
 * then query with `.in('room_id', ids)` — two requests, the second unable to
 * start until the first came back. Four modules doing that meant opening a
 * project asked for the same room list four times and spent two round trips
 * where one would do.
 *
 * PostgREST can filter through the relationship instead. `rooms!inner(...)`
 * makes it an INNER join, so `.eq('rooms.project_id', id)` scopes the rows;
 * row-level security still checks both tables exactly as before.
 *
 * The embed comes back as a `rooms` key on every row, which is not part of
 * the row's type — `stripRoomJoin` removes it so callers get what they asked
 * for and nothing writes the extra key back.
 */

/** Filter a room-owned table by project without a second request. */
export const ROOM_JOIN = 'rooms!inner(project_id)';

export function stripRoomJoin<T>(rows: unknown[] | null | undefined): T[] {
  return (rows ?? []).map((row) => {
    if (row === null || typeof row !== 'object') return row as T;
    const { rooms: _embedded, ...rest } = row as Record<string, unknown>;
    return rest as T;
  });
}
